import React from 'react';
import { TouchableOpacity, type StyleProp, type ViewStyle } from 'react-native';

type IconButtonProps = {
  onPress?: () => void;
  accessibilityLabel: string;
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  hitSlop?: { top: number; bottom: number; left: number; right: number };
};

const DEFAULT_HIT_SLOP = { top: 8, bottom: 8, left: 8, right: 8 };

const IconButton: React.FC<IconButtonProps> = ({
  onPress,
  accessibilityLabel,
  children,
  style,
  hitSlop = DEFAULT_HIT_SLOP,
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      hitSlop={hitSlop}
      style={[
        { width: 40, height: 40, alignItems: 'center', justifyContent: 'center' },
        style,
      ]}
    >
      {children}
    </TouchableOpacity>
  );
};

export default IconButton;





